import { expand } from 'uri-template-lite';
import { Page, PageRequestParams } from '../../common/queryClient';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { ISODate } from '../../common/utils';
import { UserUrl } from './UserUrl';
import { UserDirectoryDto } from '../types';

export interface UserDirectoryFilter {
  search?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  roles?: number[];
  validFrom?: ISODate;
  validTo?: ISODate;
  isAdmin?: boolean;
  isSuperadmin?: boolean;
  accessGroupId?: number;
  groupId?: number;
}

export type UserDirectoryFilterKey = keyof UserDirectoryFilter;

type UserQueryParams = UserDirectoryFilter &
  PageRequestParams<keyof UserDirectoryFilter>;

const getUsers = (params?: UserQueryParams) =>
  apiClient
    .get<Page<UserDirectoryDto>>(expand(UserUrl.USER, params))
    .then((response) => response.data);

export const useUsersQuery = createApiQueryHook(['users'], getUsers);
